"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = exports.isLoggedIn = exports.authInit = exports.handleAuthenticatingPage = exports.getToken = exports.refreshToken = void 0;
var axios_1 = require("axios");
var store_1 = require("./store");
var __constants__1 = require("./__constants__");
exports.refreshToken = function (refresh_token) { return __awaiter(void 0, void 0, void 0, function () {
    var code_verifier, client_id, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                code_verifier = store_1.getStoredData()[__constants__1.constants.CODE_VERIFIER_KEY];
                client_id = store_1.getStoredData()[__constants__1.constants.CLIENT_ID_KEY];
                if (!(code_verifier && client_id)) return [3 /*break*/, 2];
                return [4 /*yield*/, axios_1.default.post(__constants__1.constants.POD_AUTH_BASE_URL + "/oauth2/token", null, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: {
                            refresh_token: refresh_token,
                            code_verifier: code_verifier,
                            grant_type: 'refresh_token',
                            client_id: client_id,
                        },
                    })];
            case 1:
                data = _a.sent();
                setSession(data);
                return [2 /*return*/, data.data.access_token];
            case 2: throw ReferenceError('There is no code verifier or client id');
            case 3: return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.getToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var store, access_token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                store = store_1.getStoredData();
                if (!(store && store[__constants__1.constants.TOKEN_KEY] && !isTokenExpired())) return [3 /*break*/, 1];
                return [2 /*return*/, store[__constants__1.constants.TOKEN_KEY]];
            case 1:
                if (!(store && store[__constants__1.constants.REFRESH_TOKEN_KEY])) return [3 /*break*/, 3];
                return [4 /*yield*/, exports.refreshToken(store[__constants__1.constants.REFRESH_TOKEN_KEY])];
            case 2:
                access_token = _a.sent();
                return [2 /*return*/, access_token];
            case 3: throw ReferenceError('Token and RefreshToken is undefinded');
        }
    });
}); };
exports.handleAuthenticatingPage = function (onSuccess, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var params, code, data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                params = new URL(window.location.href).searchParams;
                code = params.get('code');
                if (!code) return [3 /*break*/, 2];
                return [4 /*yield*/, axios_1.default.post(__constants__1.constants.POD_AUTH_BASE_URL + "/oauth2/token", null, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: {
                            code_verifier: store_1.getStoredData()[__constants__1.constants.CODE_VERIFIER_KEY],
                            code: code,
                            grant_type: 'authorization_code',
                            client_id: store_1.getStoredData()[__constants__1.constants.CLIENT_ID_KEY],
                            redirect_uri: store_1.getStoredData()[__constants__1.constants.REDIRECT_URL_KEY],
                        },
                    })];
            case 1:
                data = _a.sent();
                setSession(data);
                if (onSuccess)
                    onSuccess();
                return [3 /*break*/, 3];
            case 2: throw ReferenceError('there is no code');
            case 3: return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                if (onError)
                    onError();
                throw error_2;
            case 5: return [2 /*return*/];
        }
    });
}); };
function authInit(config) {
    return __awaiter(this, void 0, void 0, function () {
        var codeVerifier, codeChallenge;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    codeVerifier = generateRandomString();
                    store_1.addNewItemToStore({
                        key: __constants__1.constants.CODE_VERIFIER_KEY,
                        value: codeVerifier,
                    });
                    store_1.addNewItemToStore({
                        key: __constants__1.constants.CLIENT_ID_KEY,
                        value: config.clientId,
                    });
                    store_1.addNewItemToStore({
                        key: __constants__1.constants.REDIRECT_URL_KEY,
                        value: config.redirectUri,
                    });
                    return [4 /*yield*/, generateCodeChallenge(codeVerifier)];
                case 1:
                    codeChallenge = _a.sent();
                    location.href = getAuthorizeUrl(__assign(__assign({}, config), { codeChallenge: codeChallenge }));
                    return [2 /*return*/];
            }
        });
    });
}
exports.authInit = authInit;
function getAuthorizeUrl(_a) {
    var clientId = _a.clientId, redirectUri = _a.redirectUri, scope = _a.scope, codeChallenge = _a.codeChallenge;
    return __constants__1.constants.POD_AUTH_BASE_URL + "oauth2/authorize/index.html?client_id=" + clientId + "&response_type=code&redirect_uri=" + redirectUri + "&code_challenge_method=S256&code_challenge=" + codeChallenge + "&scope=" + scope + "&prompt=none";
}
function generateRandomString() {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
function generateCodeChallenge(codeVerifier) {
    return __awaiter(this, void 0, void 0, function () {
        var digest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier))];
                case 1:
                    digest = _a.sent();
                    return [2 /*return*/, btoa(String.fromCharCode.apply(String, __spread(new Uint8Array(digest))))
                            .replace(/=/g, '')
                            .replace(/\+/g, '-')
                            .replace(/\//g, '_')];
            }
        });
    });
}
exports.isLoggedIn = function () {
    return Boolean(store_1.getStoredData() &&
        store_1.getStoredData()[__constants__1.constants.TOKEN_KEY] &&
        store_1.getStoredData()[__constants__1.constants.REFRESH_TOKEN_KEY]);
};
var getCurrentDateInSeconds = function () { return Math.floor(Date.now() / 1000); };
var setSession = function (_a) {
    var data = _a.data;
    var access_token = data.access_token, expires_in = data.expires_in, refresh_token = data.refresh_token;
    store_1.addNewItemToStore({
        key: __constants__1.constants.TOKEN_KEY,
        value: access_token,
    });
    store_1.addNewItemToStore({
        key: __constants__1.constants.REFRESH_TOKEN_KEY,
        value: refresh_token,
    });
    store_1.addNewItemToStore({
        key: __constants__1.constants.EXPIRES_IN_KEY,
        value: getCurrentDateInSeconds() + expires_in,
    });
};
var isTokenExpired = function () {
    return getCurrentDateInSeconds() >
        store_1.getStoredData()[__constants__1.constants.EXPIRES_IN_KEY] - 20;
};
exports.auth = {
    refreshToken: exports.refreshToken,
    getToken: exports.getToken,
    handleAuthenticatingPage: exports.handleAuthenticatingPage,
    isLoggedIn: exports.isLoggedIn,
    isTokenExpired: isTokenExpired,
    setSession: setSession,
};
//# sourceMappingURL=auth.js.map